import factory from '../requestFactory';

export default ({fid}) => {
    return factory()
        .get(`/patient/diagnostic-files/${fid}/timer-end`)
};
